import { forwardRef, JSX } from "react";
import { Condition } from "shared/src/data/medication-condition-pairs";

import styles from "./fda-eligibility-popover-content.module.scss";

type FdaEligibilityCondition = Condition.OBESITY | Condition.TYPE_2_DIABETES;

const contentForConditionMap: Record<FdaEligibilityCondition, JSX.Element> = {
  [Condition.OBESITY]: (
    <>
      {"Eligibility Based on FDA-Approved Use"}
      <ul>
        <li>
          <strong>{"Starting treatments:"}</strong>
          <br />
          {"The patient has a BMI ≥ 30 kg/m²"}
          <br />
          {"OR"}
          <br />
          {"BMI ≥ 27 kg/m² with weight-related comorbidities"}
          {"(e.g., high blood pressure, sleep apnea, PCOS)"}
        </li>
        <li>
          <strong>{"Continuing treatments:"}</strong>
          <br />
          {"The patient has lost or maintained at least 5% of body"}
          {"weight since starting treatments"}
        </li>
      </ul>
    </>
  ),
  [Condition.TYPE_2_DIABETES]: (
    <>
      <p>
        <strong>
          {"Eligibility Based on FDA Guidelines for Type 2 Diabetes (T2D):"}
        </strong>
      </p>
      <p>
        {"A diagnosis of T2D can be confirmed by any one of the following:"}
      </p>
      <ul>
        <li>{"Hemoglobin A1C ≥ 6.5%"}</li>
        <li>
          {"2-hour plasma glucose ≥ 200 mg/dL during an oral glucose tolerance"}
          {"test (OGTT)"}
        </li>
        <li>{"Fasting plasma glucose (FPG) ≥ 126 mg/dL"}</li>
        <li>
          {"Random plasma glucose ≥ 200 mg/dL with symptoms of hyperglycemia"}
          <br />
          {"(e.g., excessive thirst, frequent urination, extreme hunger) or"}
          {"evidence of a hyperglycemic crisis"}
        </li>
      </ul>
    </>
  ),
};

type FdaEligibilityPopoverContentProps = {
  condition: FdaEligibilityCondition;
};

export const FdaEligibilityPopoverContent = forwardRef<
  HTMLDivElement,
  FdaEligibilityPopoverContentProps
>(({ condition }, ref) => (
  <div className={styles.fdaEligibility} ref={ref}>
    {contentForConditionMap[condition]}
  </div>
));
